import { tryHandlersInOrder } from "../helpers";
import {
  handleDeepLink,
  handleDefault,
  handleEntryNotification,
  handleSchemePath,
  handleSecondLogin,
} from "./handlers";

export const handlePostAuthRedirect = async () => {
  await tryHandlersInOrder([
    handleSecondLogin,
    handleEntryNotification,
    handleSchemePath,
    handleDeepLink,
    handleDefault,
  ]);
};
